import { NotificationActionType } from 'src/types/notification';

export const checkShowNotifications = (
    notificationsActions: NotificationActionType[],
    userPermissions?: string[]
): NotificationActionType[] => {
    if (!userPermissions) {
        return [];
    }
    return notificationsActions.filter((action) => {
        switch (action.NAID) {
            case 'CLAIM.CREATE':
            case 'CLAIM.UPDATE':
            case 'RECEIVING.CREATE':
            case 'RECEIVING.UPDATE':
            case 'RETURN.CREATE':
            case 'RETURN.UPDATE':
            case 'STOCK_TAKING.CREATE':
            case 'STOCK_TAKING.UPDATE':
            case 'TRANSPORT.CREATE':
            case 'TRANSPORT.UPDATE':
                if (!userPermissions.includes(action.NAID)) {
                    return false;
                }
                break;
            case 'CLAIM.UPDATE_STATUS_CONFIRMED':
            case 'CLAIM.REMINDER':
            // Specifické notifikace pro stavy reklamací
            case 'CLAIM.UPDATE_STATUS.INPROCESS':
            case 'CLAIM.UPDATE_STATUS.ACCEPTED':
            case 'CLAIM.UPDATE_STATUS.MOREINFONEEDED':
            case 'CLAIM.UPDATE_STATUS.ACCEPTEDWAITINGFORCOMPENSATIONFROMSHIPPER':
            case 'CLAIM.UPDATE_STATUS.ACCEPTEDPENDINGCLIENTCOMPENSATION':
            case 'CLAIM.UPDATE_STATUS.REJECTED':
            case 'CLAIM.UPDATE_STATUS.STORNO':
                if (!userPermissions.includes('CLAIM.LIST')) {
                    return false;
                }
                break;
            case 'ORDER.SENT_TODAY_B2B':
            case 'ORDER.SENT_TODAY_B2C':
            case 'ORDER.REMINDER':
            case 'ORDER.SHIPPING.ZASILKOVNA.INVALID_DISPESING_POINT':
            // Specifické notifikace pro stavy objednávek
            case 'ORDER.UPDATE_STATUS.PRODUCTSNOTAVAILABLE':
            case 'ORDER.UPDATE_STATUS.WAITINGFORPAYMENT':
            case 'ORDER.UPDATE_STATUS.CANCELED':
            case 'ORDER.UPDATE_STATUS.INCORRECT':
            case 'ORDER.UPDATE_STATUS.SUSPENDED':
            case 'ORDER.UPDATE_STATUS.WAITINGFORSHIPMENT':
            case 'ORDER.UPDATE_STATUS.RECEIVED':
            case 'ORDER.UPDATE_STATUS.INPROCESS':
            case 'ORDER.UPDATE_STATUS.PACKED':
            case 'ORDER.UPDATE_STATUS.WAITINGFORCARRIER':
            case 'ORDER.UPDATE_STATUS.ONTHEWAY':
            case 'ORDER.UPDATE_STATUS.LOST':
            case 'ORDER.UPDATE_STATUS.NOTDELIVERED':
            case 'ORDER.UPDATE_STATUS.RETURNINGBACK':
            case 'ORDER.UPDATE_STATUS.RETURNEDBACK':
            case 'ORDER.UPDATE_STATUS.DELIVERED':
            case 'ORDER.UPDATE_STATUS.PRERECEIVED':
                if (!userPermissions.includes('ORDER.LIST')) {
                    return false;
                }
                break;
            case 'RECEIVING.UPDATE_PRODUCTS_INCOMPLETE':
            case 'RECEIVING.REMINDER':
            case 'RECEIVING.UPDATE_STATUS_CONFIRMED':
            // Specifické notifikace pro stavy příjemek
            case 'RECEIVING.UPDATE_STATUS.UNLOADED':
            case 'RECEIVING.UPDATE_STATUS.RECEIVED':
            case 'RECEIVING.UPDATE_STATUS.CONFIRMED':
            case 'RECEIVING.UPDATE_STATUS.CANCELED':
                if (!userPermissions.includes('RECEIVING.LIST')) {
                    return false;
                }
                break;
            case 'PRODUCT.ROP':
            case 'PRODUCT.TRASH_EVENT_RECORDED':
                if (!userPermissions.includes('PRODUCT.LIST')) {
                    return false;
                }
                break;
            case 'RETURN.REMINDER':
            case 'RETURN.UPDATE_STATUS_CONFIRMED':
            // Specifické notifikace pro stavy vratek
            case 'RETURN.UPDATE_STATUS.RECEIVED':
            case 'RETURN.UPDATE_STATUS.CONFIRMED':
            case 'RETURN.UPDATE_STATUS.CANCELED':
                if (!userPermissions.includes('RETURN.LIST')) {
                    return false;
                }
                break;
            case 'TRANSPORT.UPDATE_STATUS.CREATED':
            case 'TRANSPORT.UPDATE_STATUS.SHIPPINGCREATED':
            case 'TRANSPORT.UPDATE_STATUS.ONTHEWAY':
            case 'TRANSPORT.UPDATE_STATUS.DELIVERED':
            case 'TRANSPORT.UPDATE_STATUS.RETURNINGBACK':
            case 'TRANSPORT.UPDATE_STATUS.RETURNEDBACK':
            case 'TRANSPORT.UPDATE_STATUS.CANCELED':
            case 'TRANSPORT.UPDATE_STATUS.INCORRECT':
            case 'TRANSPORT.UPDATE_STATUS.LOST':
                if (!userPermissions.includes('TRANSPORT.LIST')) {
                    return false;
                }
                break;
            case 'JOB.UPDATE_STATUS':
                if (!userPermissions.includes('JOBS.LIST')) {
                    return false;
                }
                break;
            case 'STOCK_TAKING.UPDATE_STATUS':
                if (!userPermissions.includes('STOCK_TAKING.LIST')) {
                    return false;
                }
                break;
            default:
                console.log('missing', action.NAID);
        }
        return true;
    });
};
